import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import { GET_SYSTEM_LIST, GET_REGISTER_SYSTEM_FORM_VISIBILITY, GET_SELECTED_SYSTEM } from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_SYSTEM_LIST](state: State) {
        return state.systems;
    },
    [GET_REGISTER_SYSTEM_FORM_VISIBILITY](state: State) {
        return state.showRegisterForm;
    },
    [GET_SELECTED_SYSTEM](state: State) {
        return state.systemSelected;
    },
};
